import CentralInstance from './CentralInstance.vue';
export default CentralInstance;
